module.exports = __webpack_public_path__ + "img/d3.e1037690.jpg";